import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { initialState } from './PositionAutomation.state';
import { createActions } from './PositionAutomation.actions';

export const createPositionAutomationStore = (jobId) =>
    create(
        immer((set, get) => ({
            ...initialState,
            ...createActions(set, get, jobId),
        })),
    );
